import { createStore } from 'vuex'

export default createStore({
    state() {
        return {
            message: null
        }
    },
    mutations: {
        setMessage(state, msg) {
            state.message = msg;
        },
        clearMessage(state) {
            state.message = null;
        }
    },
    actions: {

    },
    getters: {
        message: state => state.message
    }
})